<template>
  <div class="hello">
     <div class="ps-page--my-account">
        <div class="ps-breadcrumb">
            <div class="container">
                <ul class="breadcrumb">
                    <li><a href="/home">Home</a></li>
                    <li>Reset password</li>
                </ul>
            </div>
        </div>
        <div class="ps-my-account">
            <div class="container">

                <form class="ps-form--account ps-tab-root" @submit.prevent="resetpassword">
                    <div  class="alert alert-primary" role="alert">
                        A verification code has been sent to you mail.
                      </div>
                        <div  v-if="failed" class="alert alert-danger" role="alert">
                        {{ errorm }}
                      </div>
                        <div class="ps-tab active">

                       <div v-if="sent" class="spinner-border" role="status">
                         <span class="visually-hidden">Loading...</span>
                      </div>
                            <div class="ps-form__content">
                                <h5>Reset password ?</h5>
                                <div class="form-group">
                                    <input class="form-control"
                                    type="text"
                                    placeholder="Your email address"
                                    required
                                    v-model="user.email">
                                </div>

                                 <div class="form-group">
                                    <input class="form-control"
                                    type="text"
                                    placeholder="Type verification code here"
                                    required
                                    v-model="user.token">
                                </div>

                                 <div class="form-group">
                                    <input class="form-control"
                                    type="password"
                                    placeholder="Type your new password"
                                    required
                                    v-model="user.password">
                                </div>

                                   <div class="form-group">
                                    <input class="form-control"
                                    type="password"
                                    placeholder="Confirm new password "
                                    required
                                    v-model="user.confirmation">
                                </div>

                                <div class="form-group submtit">
                                    <button @click="resetpassword" :disabled="clicked" class="ps-btn ps-btn--fullwidth">Change Password</button>
                                </div>
                            </div>
                             <div class="ps-form__footer">

                                <ul class="ps-list--social">

                                </ul>
                            </div>

                        </div>

                </form>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import DataService from "@/services/DataService";
export default {
  name: 'ResetPassword',
  data () {
    return {
        clicked: false,
        sent : false,
      failed : false,
      errorm : "",
       user: {
        email: "",
        token: "",
        password: "",
        confirmation:""

      }
    }
  },
      methods: {
    resetpassword() {
      var data = {
        email: this.user.email,
        token: this.user.token,
        password: this.user.password,
        password_confirmation: this.user.confirmation
      };

       this.clicked = true;

       // do something to process the like
        console.log(data);
        this.sent = true;
         this.user= { email: "",token: "", password: "",confirmation:""};
      DataService.password_reset_validate_post(data)
        .then(response => {

          console.log(response);
          this.sent = false;
          alert("Your password has successfully been reset.");
          this.$router.push('/login');

        }).catch(error => {
          console.log(error.response.data.message);
          this.sent = false;
          this.errorm = this.$parent.translate_error_message(e.response.data.errors,"errors");
          this.failed = true;
        });

      setTimeout(function(){
        this.clicked = false;
       }.bind(this),1000);

    }
},
  created(){
        this.$emit("giveway",false);
         console.log("we are in the resetpassword created function");
         this.$emit("headerAndFooter");
     },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/ResetPassword.vue